import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import MinimalRouter from 'static/script/utils/minimal-router';
import memberInfo from 'static/script/app/data/member-info';

function FavouriteSellersUI() {

    let BUTTON_STATE = {
        'NOT_ADDED': 'NOT_ADDED',
        'ADDED': 'ADDED'
    };

    this.defaultAttrs({
        addedCssClass: 'toggle--on',
        disabledCssClass: 'disabled',
        hashParam: 'favouriteSeller'
    });

    this._buttonClicked = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        let payload = {};
        if (this._isDisabled()) {
            return;
        }

        this._trackNavigation();
        this._disableButton();

        if (!memberInfo.isLoggedIn) {
            let destination = location.protocol + '//' + location.host + location.pathname + location.search + '#favouriteSeller=' + this._sellerId;
            this.trigger(document, 'ui:login:show', { destination: encodeURIComponent(destination) });
            return;
        }

        if (this._getButtonState() === BUTTON_STATE.NOT_ADDED) {
            payload.sellerId = this._sellerId;
            this.trigger('ui:favourite-sellers:on-adding', payload);
        } else {
            payload.ids = [this._sellerId];
            this.trigger('ui:favourite-sellers:on-removing', payload);
        }
    };

    this._afterAdded = function () {
        this._enableButton();
        this._setButtonState(BUTTON_STATE.ADDED);
    };

    this._afterRemoved = function (evt, payload) {
        if (payload.ids && payload.ids.indexOf(this._sellerId) > -1) {
            this._enableButton();
            this._setButtonState(BUTTON_STATE.NOT_ADDED);
        }
    };

    this._enableButton = function () {
        this._toggleButtonEnabled(true);
    };

    this._disableButton = function () {
        this._toggleButtonEnabled(false);
    };

    this._isDisabled = function () {
        return this.$node.hasClass(this.attr.disabledCssClass);
    };

    this._toggleButtonEnabled = function (enable) {
        enable = (enable === undefined) ? !this._isDisabled : enable;
        this.$node.toggleClass(this.attr.disabledCssClass, !enable);
    };

    this._getButtonState = function () {
        return this.$node.hasClass(this.attr.addedCssClass) ? BUTTON_STATE.ADDED : BUTTON_STATE.NOT_ADDED;
    };

    this._setButtonState = function (state) {
        if (state === BUTTON_STATE.NOT_ADDED) {
            this.$node.removeClass(this.attr.addedCssClass);
        } else if (state === BUTTON_STATE.ADDED) {
            this.$node.addClass(this.attr.addedCssClass);
        }
    };

    this._userReturnedAfterLogin = function () {
        let userIdFromHash = parseInt(this.getValueFromHashParam(this.attr.hashParam), 10);

        this.removeHashFromCurrentUrl();

        if (userIdFromHash === this._sellerId && !this.$node.hasClass(this.attr.addedCssClass)) {
            this.trigger('click');
        }
    };

    this._trackNavigation = function () {
        this.trigger(document, 'analytics:track-event', {
            category: this._location,
            action: 'Toggle favourite seller',
            label: (this._getButtonState() === BUTTON_STATE.NOT_ADDED) ? 'Add' : 'Remove'
        });
    };

    this.after('initialize', function () {
        this._location = this.$node.data('favourite-seller-location');
        this._sellerId = this.$node.data('favourite-seller-add');

        if (!this._location || !this._sellerId) {
            return;
        }

        this.on('click', this._buttonClicked);

        this.on(document, 'data:favourite-sellers:after-added', this._afterAdded);
        this.on(document, 'data:favourite-sellers:after-removed', this._afterRemoved);

        this.defineHashRoute(this.attr.hashParam + '=(.*)', this._userReturnedAfterLogin);
    });
}

module.exports = defineComponent.component(FavouriteSellersUI, MinimalRouter);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/favourite-sellers-ui.js